import { render, staticRenderFns } from "./preintPatientList.vue?vue&type=template&id=6db076a2&scoped=true"
import script from "./preintPatientList.vue?vue&type=script&lang=js"
export * from "./preintPatientList.vue?vue&type=script&lang=js"
import style0 from "./preintPatientList.vue?vue&type=style&index=0&id=6db076a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db076a2",
  null
  
)

export default component.exports